/**
 * @generated SignedSource<<dc36b5ffe1f417d2439c812c25ad2d31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreExtraAdminFieldType = "STRING" | "STRING_LIST";
export type StoreOrgUpdateInput = {
  setAddress?: string | null;
  setExternalId?: string | null;
  setExtraFields?: ReadonlyArray<StoreExtraAdminFieldInput> | null;
  setLocale?: string | null;
  setName?: string | null;
  setPlaceId?: string | null;
  setTimezone?: string | null;
  setWorkspaceId?: string | null;
};
export type StoreExtraAdminFieldInput = {
  key: string;
  value: string;
};
export type OrgStoreAdminUpdateStoreMutation$variables = {
  input: StoreOrgUpdateInput;
  storeId: string;
};
export type OrgStoreAdminUpdateStoreMutation$data = {
  readonly store: {
    readonly updateByOrg: {
      readonly address: string | null;
      readonly externalId: string | null;
      readonly extraAdminFields: ReadonlyArray<{
        readonly description: string | null;
        readonly key: string;
        readonly label: string;
        readonly type: StoreExtraAdminFieldType;
        readonly value: string | null;
      }>;
      readonly id: string;
      readonly locale: string;
      readonly name: string;
      readonly timezone: string;
      readonly workspaceOwner: {
        readonly id: string;
      } | null;
    };
  };
};
export type OrgStoreAdminUpdateStoreMutation = {
  response: OrgStoreAdminUpdateStoreMutation$data;
  variables: OrgStoreAdminUpdateStoreMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "updateByOrg",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timezone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaceOwner",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreExtraAdminField",
            "kind": "LinkedField",
            "name": "extraAdminFields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgStoreAdminUpdateStoreMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgStoreAdminUpdateStoreMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5b8d4053b842d65865a611f00c11d1e9",
    "id": null,
    "metadata": {},
    "name": "OrgStoreAdminUpdateStoreMutation",
    "operationKind": "mutation",
    "text": "mutation OrgStoreAdminUpdateStoreMutation(\n  $input: StoreOrgUpdateInput!\n  $storeId: ID!\n) {\n  store(id: $storeId) {\n    updateByOrg(input: $input) {\n      id\n      name\n      timezone\n      locale\n      externalId\n      address\n      workspaceOwner {\n        id\n      }\n      extraAdminFields {\n        key\n        label\n        description\n        type\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1fd08f985c0e837812266dfb8292d77";

export default node;
